import { createReducer, on } from '@ngrx/store';

import _ from 'lodash';

import { initialAppState } from './app.state';
import {
  setApiVersion,
  setHasUnseenVersion,
  setIsAppInitialized,
  setIsPagesComponentExisting,
  setTabs,
  setUnseenPOSVersion,
} from './app.actions';

import { Tab } from 'src/models/Tab';

import { VersionInfoDTO } from 'src/dtos/updates/VersionInfoDTO';

export const appReducer = createReducer(
  initialAppState,

  on(setApiVersion, (state, action) => {
    const apiVersion: string = action.apiVersion;
    localStorage.setItem('apiVersion', apiVersion);

    return {
      ...state,
      apiVersion,
    };
  }),

  on(setIsAppInitialized, (state, action) => {
    const isAppInitialized: boolean = action.isAppInitialized;

    return {
      ...state,
      isAppInitialized,
    };
  }),

  on(setIsPagesComponentExisting, (state, action) => {
    const exists: boolean = action.exists;

    return {
      ...state,
      isPagesComponentExisting: exists,
    };
  }),

  on(setTabs, (state, action) => {
    const tabs: Tab[] = action.tabs;

    if (_.isEqual(tabs, state.tabs)) {
      return { ...state, tabs: state.tabs };
    }

    return {
      ...state,
      tabs,
    };
  }),

  on(setHasUnseenVersion, (state, action) => {
    const hasUnseenVersion: boolean = action.hasUnseenVersion;

    return {
      ...state,
      hasUnseenVersion,
    };
  }),

  on(setUnseenPOSVersion, (state, action) => {
    const unseenPOSVersion: VersionInfoDTO | undefined =
      action.unseenPOSVersion;

    return {
      ...state,
      unseenPOSVersion,
    };
  })
);
